import { createSlice } from "@reduxjs/toolkit";

const WORKSPACE_KEY = "workspace_scope";

// Lấy giá trị khởi tạo từ localStorage (mặc định "admin")
const getInitial = () => localStorage.getItem(WORKSPACE_KEY) || "admin";

const workspaceSlice = createSlice({
  name: "workspace",
  initialState: {
    value: getInitial(), // "admin" | "member"
  },
  reducers: {
    setWorkspace(state, action) {
      state.value = action.payload === "member" ? "member" : "admin";
      localStorage.setItem(WORKSPACE_KEY, state.value);
    },
    toggleWorkspace(state) {
      state.value = state.value === "admin" ? "member" : "admin";
      localStorage.setItem(WORKSPACE_KEY, state.value);
    },
    resetWorkspace(state) {
      state.value = "admin";
      localStorage.setItem(WORKSPACE_KEY, "admin");
    },
  },
});

export const { setWorkspace, toggleWorkspace, resetWorkspace } =
  workspaceSlice.actions;

// Selector tiện dụng
export const selectWorkspace = (state) => state.workspace.value;

export default workspaceSlice.reducer;
